import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"

const application = Application.start()
window.Stimulus = application

const controllers = import.meta.glob("../javascripts/**/*_controller.js", {
  eager: true,
})

registerControllers(application, controllers)
